import { Link } from "react-router-dom";
import { Button } from "./ui/button";
import {
  NavigationMenu,
  NavigationMenuItem,
  NavigationMenuList,
} from "./ui/navigation-menu";


import { Menu, PhoneCall, ChevronDown } from "lucide-react";
import {
  NavigationMenuContent,
  NavigationMenuTrigger,
} from "./ui/navigation-menu";
import { useIsMobile } from "@/hooks/use-mobile";
import { Sheet, SheetContent, SheetTrigger } from "./ui/sheet";
import { MobileNav } from "./navbar/MobileNav";

export const Navbar = () => {
  const isMobile = useIsMobile();

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-background border-b border-border shadow-sm transition-all duration-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <div className="flex-shrink-0">
            <Link to="/" className="text-xl font-bold text-primary hover:scale-105 transition-transform duration-200">
              TheGrowthBy
            </Link>
          </div>

          {/* Desktop Navigation Menu */}
          <div className="hidden md:block">
            <NavigationMenu>
              <NavigationMenuList className="gap-6">
                <NavigationMenuItem>
                  <Link to="/how-it-works" className="px-3 py-2 text-sm font-medium hover:text-primary transition-colors">
                    How It Works
                  </Link>
                </NavigationMenuItem>
                <NavigationMenuItem>
                  <NavigationMenuTrigger className="text-sm font-medium">Who We Help</NavigationMenuTrigger>
                  <NavigationMenuContent>
                    <ul className="grid w-[280px] gap-1 p-3">
                      <li>
                        <Link to="/service-businesses" className="block p-3 rounded-md hover:bg-muted transition-colors">
                          <div className="font-medium text-foreground text-sm">Service Businesses</div>
                          <p className="text-xs text-muted-foreground mt-0.5">Dentists, clinics, fitness gyms, consultants</p>
                        </Link>
                      </li>
                      <li>
                        <Link to="/education" className="block p-3 rounded-md hover:bg-muted transition-colors">
                          <div className="font-medium text-foreground text-sm">Education Institutes</div>
                          <p className="text-xs text-muted-foreground mt-0.5">Schools, training centers, universities</p>
                        </Link>
                      </li>
                      <li>
                        <Link to="/restaurants" className="block p-3 rounded-md hover:bg-muted transition-colors">
                          <div className="font-medium text-foreground text-sm">Restaurants</div>
                          <p className="text-xs text-muted-foreground mt-0.5">QSR, cafes, multi-location chains</p>
                        </Link>
                      </li>
                    </ul>
                  </NavigationMenuContent>
                </NavigationMenuItem>
                <NavigationMenuItem>
                  <Link to="/case-studies" className="px-3 py-2 text-sm font-medium hover:text-primary transition-colors">
                    Our Clients
                  </Link>
                </NavigationMenuItem>
                <NavigationMenuItem>
                  <Link to="/about" className="px-3 py-2 text-sm font-medium hover:text-primary transition-colors">
                    About Us
                  </Link>
                </NavigationMenuItem>
              </NavigationMenuList>
            </NavigationMenu>
          </div>

          {/* Contact Us Button and Mobile Menu */}
          <div className="flex items-center gap-4">
            <Link to="/contact">
              <Button size="sm" className="gap-2">
                {isMobile ? <PhoneCall className="h-5 w-5" /> : "Contact Us"}
              </Button>
            </Link>

            {/* Mobile Menu Button */}
            <div className="md:hidden">
              <Sheet>
                <SheetTrigger asChild>
                  <Button variant="ghost" size="icon">
                    <Menu className="h-6 w-6" />
                  </Button>
                </SheetTrigger>
                <SheetContent side="right" className="p-0">
                  <MobileNav />
                </SheetContent>
              </Sheet>
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
};